export default {
    queryPageList: '/basic/blacks/queryPageList', // 获取list
    setTime: '/basic/mpp/changeDate', // 设置时间 重置时间
    delete: '/basic/blacks/delete', // 黑名单删除
    change: '/basic/blacks/change', // 黑名单修改
    getTime: '/basic/mpp/getDate', // 获取默认时间
    postmould: '/basic/mpp/mould', // 模板保存
    getmould: '/basic/mpp/mould', // 模板查询
    getAll: '/basic/mpp/getAll' // 查询所有模板
};
